<section class="app-abo-us-top" [id]="AboutUsSection.TOP" [appAnimate]="'fadeIn'" [speed]="'faster'">
  <img
    class="app-abo-us-top__bg"
    [priority]="true"
    alt="PRO.CONNECT COMMUNITY valued, inspired, educated"
    ngSrc="assets/images/pages/about-us/banner.webp"
    [fill]="true"
  />
</section>
